import { CustomIconName, EmptyState } from '@ketch-com/deck'
import React from 'react'

type NoDataEmptyStateProps = {
  title?: string
  subtitle?: string
  iconName?: CustomIconName
}

export const NoDataEmptyState: React.FC<NoDataEmptyStateProps> = ({
  title = 'No Data',
  subtitle = 'We couldn’t find any records for this identifier. Make sure you’ve selected the correct identifier and value.',
  iconName = 'OFingerprint',
}) => <EmptyState size="large" iconName={iconName} title={title} subTitle={subtitle} />
